<!--
 * @Description: 运维统计
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-22 15:41:18
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-06 16:23:16
 -->
<template>
  <div class="maintenanceStatistics">
    <div class="item" v-for="(item, index) in statisticsList" :key="index">
      <div class="label" :style="{'background-image':'url(' + item.bgSrc + ')'}">{{item.label}}</div>
      <div class="value">{{item.value}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'maintenanceStatistics',
  components: {
  },
  data () {
    return {
      statisticsList: [
        {
          name: 'device',
          label: '维护设备总数',
          value: 0,
          bgSrc: '/static/img/layout/titleBg-green.png',
        },
        {
          name: 'user',
          label: '系统用户总数',
          value: 0,
          bgSrc: '/static/img/layout/titleBg-yellow.png',
        },
        {
          name: 'mileage',
          label: '维护总公里数',
          value: 0,
          bgSrc: '/static/img/layout/titleBg-blue.png',
        },
        {
          name: 'station',
          label: '收费站总数',
          value: 0,
          bgSrc: '/static/img/layout/titleBg-green.png',
        },
      ],
    }
  },
  methods: {
    /**
     * @description                   获取数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/lcgl/summary').then(res => {
        if (res.code === 0) {
          this.statisticsList.map(k => {
            k.value = res.data[k.name]
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .maintenanceStatistics {
    width: 100%;
    height: 100%;
    background: url('/static/img/layout/staticsBg.png');
    background-size: 100% 100%;
    .item {
      width: 50%;
      height: 50%;
      display: inline-block;
      text-align: center;
      .label {
        display: inline-block;
        width: 147px;
        height: 37px;
        background-size: 100% 100%;
        color: #fff;
        font-size: 18px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 30px 0 20px 52px;
      }
      .value {
        display: inline-block;
        width: 50px;
        font-size: 24px;
        color: #fff;
        text-align: center;
        font-weight: bold;
        line-height: 0;
      }
    }
  }
</style>
